var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseTable',{ref:"baseTable",attrs:{"headers":_vm.fields,"items":_vm.items,"tableClasses":"item-table border","responsive":"","hide-default-footer":"","fixed-header":"","height":"200"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }